import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { S25DropdownPaginatedModule } from "../s25-dropdown/s25.dropdown.paginated.module";
import { FormsModule } from "@angular/forms";
import { S25EditableBooleanModule } from "../s25-editable/s25-editable-boolean/s25.editable.boolean.module";
import { S25EditableModule } from "../s25-editable/s25.editable.module";
import { S25IconComponent } from "../s25-icon/s25.icon.component";
import { S25TimepickerModule } from "../s25-timepicker/s25.timepicker.module";
import { S25MultiselectModule } from "../s25-multiselect/s25-multiselect.module";
import { S25CustomAttributeValueComponent } from "./s25.custom.attribute.value.component";
import { S25ToggleButtonModule } from "../s25-toggle-button/s25.toggle.button.module";
import { S25CustomAttributeOptionsComponent } from "./s25.custom.attribute.options.component";

@NgModule({
    imports: [
        CommonModule,
        S25DropdownPaginatedModule,
        FormsModule,
        S25EditableBooleanModule,
        S25EditableModule,
        S25TimepickerModule,
        S25MultiselectModule,
        S25ToggleButtonModule,
        S25IconComponent,
    ],
    exports: [S25CustomAttributeValueComponent, S25CustomAttributeOptionsComponent],
    declarations: [S25CustomAttributeValueComponent, S25CustomAttributeOptionsComponent],
    providers: [S25CustomAttributeValueComponent, S25CustomAttributeOptionsComponent],
})
export class S25CustomAttributeModule {}
